module.exports = require("././ngStorage.js");


//////////////////
// WEBPACK FOOTER
// ngstorage (bower component)
// module id = 1386
// module chunks = 1